export const TAB_INDEX_DEFAULT: number = 0;
export const TAB_INDEX_NONE: number = -1;
